package com.wintermar.inspection.feature.presentation.inspection.answer.search.util

enum class InspectionSearchQuestionType {
    QUESTION,
    PAGE,
    SECTION
}
